import { createSlice } from '@reduxjs/toolkit';
import { ProjectsSliceState } from '../../types';

export const initialState: ProjectsSliceState = {
  isProjectModalOpen: false,
  projectModalEventLocation: '',
};

const projectsSlice = createSlice({
  name: 'projectsSlice',
  initialState,
  reducers: {
    setIsProjectModalOpen(state, { payload }) {
      state.isProjectModalOpen = payload;
    },
    setProjectModalEventLocation(state, { payload }) {
      state.projectModalEventLocation = payload;
    },
  },
});

export const { setIsProjectModalOpen, setProjectModalEventLocation } =
  projectsSlice.actions;
export default projectsSlice.reducer;
